export default "assets/images/icons/exposition-b66df3c9.svg";